import { Canvas } from "@react-three/fiber";
import { Provider } from "react-redux";
import store from "./store/index";
import GumDataPro2 from "./View/Scene/components/GumDataPro2";
import { getWebviewerModelAdaptionZip } from "./http/Adaption/apiAdapter";
import { useEffect, useState } from "react";
import JSZip from "jszip";
import FileManager from "./data/manager/dataMannger";
import StageManager from "./data/manager/stageManager";
import SuperimpositionPro2 from "./View/Scene/components/SuperimpositionPro2";
import PonticDataPro2 from "./View/Scene/components/PonticDataPro2";
import IPRDataPro2 from "./View/Scene/components/IPRDataPro2";
import ToothDataPro2 from "./View/Scene/components/ToothDataPro2";
import { addPerform, logPerform } from "./tools/perform-tool";
import { EffectComposer, N8AO } from "@react-three/postprocessing";
import { OrbitControls } from "@react-three/drei";
import { connect } from "react-redux";
import action from "./store/action";

const Render = ({ children }) => {
  return (
    <Canvas
      style={{ width: "100vw", height: "100dvh" }}
      className={"canvasStyle"}
      id={"display"}
      gl={{ logarithmicDepthBuffer: true }}
      tabIndex={0}
      camera={{ position: [0, 0, 300], fov: 10, near: 1, far: 50000 }}
    >
      <directionalLight
        color={"#fff"}
        position={[0, 60, 0]}
        intensity={0.1}
      ></directionalLight>
      <directionalLight
        color={"#fff"}
        position={[0, -60, 0]}
        intensity={0.1}
      ></directionalLight>
      <directionalLight
        color={"#fff"}
        position={[0, 0, 90]}
        intensity={0.2}
      ></directionalLight>
      <directionalLight
        color={"#fff"}
        position={[0, 0, -90]}
        intensity={0.2}
      ></directionalLight>
      <directionalLight
        color={"#fff"}
        position={[90, 0, 0]}
        intensity={0.2}
      ></directionalLight>
      <directionalLight
        color={"#fff"}
        position={[-90, 0, 0]}
        intensity={0.2}
      ></directionalLight>
      <OrbitControls makeDefault enableDamping={false} />
      {children}
      <EffectComposer disableNormalPass multisampling={4}>
        <N8AO
          aoRadius={20}
          aoSamples={64}
          denoiseSamples={16}
          denoiseRadius={8}
          distanceFalloff={0.2}
          intensity={8}
          screenSpaceRadius
          halfRes
        />
      </EffectComposer>
    </Canvas>
  );
};

function Playground(props) {
  const [isLoad, setIsLoad] = useState(false);
  const { setKeyframeNumber } = props;

  const getData = async () => {
    let result = await getWebviewerModelAdaptionZip();
    if (result == null || result.data == null) {
      return;
    }

    const modelData = result.data;
    let blob = new Blob([modelData]);
    const zip = new JSZip();
    await zip.loadAsync(blob);

    addPerform({ name: "file.readFiles.start" });
    // const fileMap = await readFiles(zip);
    addPerform({ name: "file.readFiles.end" });

    await FileManager.init(zip);

    // await FileManager.loadModel();
    const stageDOList = StageManager.getStageList();
    const lastStageNumber = stageDOList[stageDOList.length - 1].stageNumber;
    const lastKeyframeNumber = lastStageNumber - 1;
    setKeyframeNumber(lastKeyframeNumber);
    await FileManager.loadModelByFirstStageNumber(lastStageNumber);

    FileManager.lazyLoadModel({
      onStageLoaded: (stageDO) => {},
    });
    setIsLoad(true);
    addPerform({ name: "file.loadFile.start" });
  };

  const readFiles = async (zip) => {
    const fileMap = new Map();
    for (let file in zip.files) {
      // console.log('>>>---', file)
      // In order to skip a folder. (file contains folders)
      if (!zip.files[file].dir) {
        await zip
          .file(file)
          .async("arraybuffer")
          .then(async (content) => {
            let blob2 = new Blob([content]);

            if (file.includes(".raw")) {
              fileMap.set(file, await loadSync(blob2));
            } else {
              let modelUrl = window.URL.createObjectURL(blob2);
              fileMap.set(file, modelUrl);
            }
          });
      }
    }
    return fileMap;
  };

  const loadSync = (blob) => {
    return new Promise((resolve, reject) => {
      // convert to base64
      let reader = new FileReader();
      reader.readAsDataURL(blob);
      let raw = "";
      reader.onload = function () {
        // delete 'data:application/octet-stream;base64', Because it needs to be properly converted to buffer
        raw = reader.result.replace(
          "data:application/octet-stream;base64,",
          ""
        );
        resolve(raw);
      };
    });
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div style={{ width: "100vw", height: "100dvh", backgroundColor: "#444" }}>
      <Render>
        {isLoad ? (
          <>
            <ToothDataPro2 />
            <SuperimpositionPro2 />
            <GumDataPro2 />
            <PonticDataPro2 />
            <IPRDataPro2 />
          </>
        ) : (
          <></>
        )}
      </Render>
    </div>
  );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setKeyframeNumber: (val) => dispatch(action.setKeyframeNumber(val)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Playground);
